<template lang="html">
  <div class="pcblayout">
    <img class="banner" :src="`${pagebase}/static/img/pcblayout/banner.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con1.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con2.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con3.png`" alt="">
    
    
    <div class="course">
      <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con4.png`" alt="">
      <div class="allCourse" @click="getCourse">
        <p>查看更多目录</p>
      </div>
    </div>
    
    <div class="courseList" v-show="listShow" @click="closeCourse">
      <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con4.png`" alt="">
      <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con5.png`" alt="">
      <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con6.png`" alt="">
      <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con7.png`" alt="">
      <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con8.png`" alt="">
      <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con9.png`" alt="">
      <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con10.png`" alt="">
    </div>
    
    <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con11.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con12.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con13.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con14.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con15.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con16.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con17.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con18.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con19.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con20.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con21.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con22.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/pcblayout/con23.png`" alt="">

    <img :src="`${pagebase}/static/img/pcblayout/consulting.png`" alt="" class="consultingIcon" @click="arrangeShow">
    <div class="footerMod">
      <div class="signUp">
        <div class="signUpPrice">
          <p class="originalCost">优惠价：<span>{{activityCon.cash_price}}</span></p>
          <p class="currentPrice">原价：<s>{{activityCon.cash_origin_price}}</s></p>
        </div>
        <div class="signUpBtn" @click="signUp">立即报名</div>
      </div>
    </div>

    <div class="consult_alert" v-bind:class="{'arrangeshow': arrangeshow}" @click="consultClose">
      <div class="consult_alert_con">
        <div class="consult_alert_ma">
          <p>保存识别二维码</p>
          <div v-html="this.activityCon.tips"></div>
          <img class="" :src="this.activityCon.qrcode" alt="">
        </div>
        <div class="consult_close_btn">
          <img class="" :src="`${pagebase}/static/img/pcblayout/close.png`" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { pagebase } from '@/utils/http.js';
  import utils from '@/utils/utils';
  import WxShare from '@/utils/wxshare';
  
  export default {
    data() {
      return {
        aid: this.$route.query.aid || '',
        activityCon: {},
        arrangeshow: false,
        pagebase: pagebase,
        listShow: false,
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.showStat();
        // 微信分享
        this.wxshare = new WxShare();
        this.getactivityCon();
      },
      showStat() {
        this.$http({
          url: '/api/showStat',
          method: 'post',
          params: {
            url: window.location.href,
          }
        })
      },
      getactivityCon() {
        this.$http({
          url: '/activity/Info',
          method: 'get',
          params: {
            activity_id: this.aid,
          },
        }).then(res => {
          if (res.code >= 0) {
            let data = res.data;
            this.activityCon = data;
            document.title = data.title;
            this.wxshare.share({
              title: data.title,
              desc: data.summary,
              link: window.location.href,
              imgUrl: data.cover,
            })
          }
        })
      },
      
      signUp() {
        var succeedUrl = encodeURIComponent(pagebase + '/#/paySucceed?activity_id=' + this.aid);
        if (utils.browserChecker.isWx()) {
          var channel = this.$route.query.channel || '';
          var open = encodeURIComponent(pagebase + '/#/payment?activity_id=' + this.aid + '&project=pcblayout' + '&channel=' + channel + '&succeed_url=' + succeedUrl);
          var url = 'http://edu.eda365.com/wechat_redirect.php?jump_url=' + open;
          window.location.href = url;
        } else {
          this.$router.push({
            path: '/payment',
            query: {
              activity_id: this.aid,
              channel: this.$route.query.channel || '',
              project: 'pcblayout',
              track_id: this.$route.query.track_id || '',
              succeed_url: succeedUrl,
            }
          })
        }
      },
      
      arrangeShow() {
        this.arrangeshow = true;
      },

      consultClose() {
        this.arrangeshow = false;
      },
      
      getCourse() {
        this.listShow = true;
      },
      
      closeCourse(){
        this.listShow = false;
      },
    }
  }
</script>

<style lang="css" scoped>
  .pcblayout {
    background-color: #1E2C33;
    padding-bottom: 8rem;
  }

  .banner {
    width: 100%;
  }

  .modImg {
    width: 100%;
    margin-top: -.4rem;
  }
  
  .course {
    position: relative;
  }
  
  .allCourse {
    box-sizing: border-box;
    width: 100%;
    height: 9rem;
    position: absolute;
    left: 0;
    bottom: 0;
    background: linear-gradient(to bottom, rgba(7, 48, 50, 0), rgba(30, 44, 51, 1));
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
  
  .allCourse p{
    font-size: 1.4rem;
    color: rgba(255, 255, 255, 0.9);
    width: 13.6rem;
    height: 3.6rem;
    line-height: 3.6rem;
    text-align: center;
    border-radius: 3.6rem;
    background-color: #208CD7;
    box-shadow: .1rem .4rem .5rem rgba(32, 140, 215, 0.3);
  }
  
  .courseList {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.8);
    overflow: auto;
    padding: 2rem 2rem;
    padding-bottom: 10rem;
  }
  
  .footerMod {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 8rem;
    background: linear-gradient(to bottom, rgba(30, 44, 51, 0.8), rgba(30, 44, 51, 1));
    z-index: 10;
  }

  .consultingIcon {
    width: 7.2rem;
    height: 7.2rem;
    position: fixed;
    right: 1rem;
    bottom: 8.5rem;
    z-index: 10;
  }

  .signUp {
    height: 3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(30, 44, 51, 0.01);
    box-sizing: border-box;
    padding: 0 3rem;
    margin-top: 1rem;
  }

  .signUpPrice {
    display: flex;
    height: 2rem;
    align-items: flex-end;
  }

  .originalCost {
    font-size: 1.6rem;
    color: #FFFFFF;
    margin-right: 1rem;
  }

  .originalCost span {
    color: #FFC851;
  }

  .currentPrice {
    font-size: 1rem;
    color: #CCCCCC;
  }

  .currentPrice span {
    color: #FFFFFF;
  }

  .signUpBtn {
    width: 10rem;
    height: 3rem;
    line-height: 3rem;
    border-radius: 3rem;
    background-color: #208CD7;
    text-align: center;
    font-size: 1.6rem;
    color: #FFFFFF;
  }

  .consult_alert {
    display: none;
    z-index: 11;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
  }

  .consult_alert_con {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -14rem;
    margin-left: -14rem;
    width: 28rem;
    height: 28rem;
    background-color: #F3F7FC;
    border-radius: 1rem;
  }

  .consult_alert_ma {
    height: 100%;
    display: flex;
    font-size: 1.8rem;
    font-weight: 600;
    color: #080943;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .consult_alert_ma img {
    width: 15rem;
    height: 15rem;
  }

  .arrangeshow {
    display: block;
  }

  .consult_close_btn {
    margin-top: .5rem;
    display: flex;
    justify-content: center;
  }

  .consult_close_btn img {
    width: 3.8rem;
    height: 3.8rem;
  }
  
  @media (min-width: 751px) {
    .courseList {
      width: 750px;
      left: 50%;
      margin-left: -375px;
    }
    
    .consultingIcon{
      right: 50%;
      margin-right: -375px;
    }
    
    .footerMod {
      width: 750px;
      left: 50%;
      margin-left: -375px;
    }
  }
</style>
